import { ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Form, FormContext } from 'dash-ui';

import { FormFields } from 'pages/brokers/BrokerDetailsPage/BrokerDetailsPage.constants';
import { useValidateBrokerInfoForm } from 'pages/brokers/BrokerDetailsPage/components/BrokerInfoForm/BrokerInfoForm.hooks';

const AgencySection = () => {
  const { t } = useTranslation('forms');
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const validate = useValidateBrokerInfoForm();

  const handleInputsValue =
    (field: FormFields) => (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      stateHandlers[field](value);
      validate(field, value);
    };

  return (
    <Flex>
      <Form.Group w="100%" mb={4}>
        <Form.Label>{t('forms:labels.subscriptionPlanName')}</Form.Label>
        <Form.Input
          disabled
          value={formState[FormFields.SubscriptionPlanName] || ''}
          onChange={(event) =>
            stateHandlers[FormFields.SubscriptionPlanName](event.target.value)
          }
        />
      </Form.Group>
      <Form.Group w="100%" mx={3.5}>
        <Form.Label>{t('labels.agencyName')}</Form.Label>
        <Form.Input
          placeholder={t('placeholders.agencyName') || ''}
          value={formState[FormFields.AgencyName] || ''}
          onChange={handleInputsValue(FormFields.AgencyName)}
          $errorType={formErrors[FormFields.AgencyName]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.AgencyName]?.type}>
          {formErrors[FormFields.AgencyName]?.message}
        </Form.Feedback>
      </Form.Group>
      <Form.Group w="100%">
        <Form.Label>{t('labels.agencyWebsite')}</Form.Label>
        <Form.Input
          placeholder={t('placeholders.url') || ''}
          value={formState[FormFields.AgencyWebsite] || ''}
          onChange={handleInputsValue(FormFields.AgencyWebsite)}
          $errorType={formErrors[FormFields.AgencyWebsite]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.AgencyWebsite]?.type}>
          {formErrors[FormFields.AgencyWebsite]?.message}
        </Form.Feedback>
      </Form.Group>
    </Flex>
  );
};

export default AgencySection;
